import { type Answers, DIAGNOSIS_VERSION } from './constants';
import { watchDebounced } from '@vueuse/core';

const LOCAL_STORAGE_ANSWERS_KEY = 'diagnosisAnswers';
const LOCAL_STORAGE_VERSION_KEY = 'diagnosisVersion';

export const useGetStoredDiagnosisAnswers = () => {
  const storedAnswers = window.localStorage.getItem(LOCAL_STORAGE_ANSWERS_KEY);
  const initialAnswers = ref<Maybe<Answers>>(
    storedAnswers ? JSON.parse(storedAnswers) : undefined
  );

  const clearInitialAnswers = () => {
    initialAnswers.value = undefined;
    window.localStorage.removeItem(LOCAL_STORAGE_ANSWERS_KEY);
    window.localStorage.removeItem(LOCAL_STORAGE_VERSION_KEY);
  };

  const savedDiagnosisVersion = window.localStorage.getItem(
    LOCAL_STORAGE_VERSION_KEY
  );
  if (savedDiagnosisVersion !== DIAGNOSIS_VERSION) {
    clearInitialAnswers();
  }

  // zodかなんかでバリデーションをかける

  return {
    initialAnswers: computed(() => initialAnswers.value),
    clearInitialAnswers,
  };
};

export const useSetStoredDiagnosisAnswers = (
  answers: RefOrGetterFunction<Answers>
) => {
  const stopSave = watchDebounced(
    answers,
    (newAnswers) => {
      window.localStorage.setItem(
        LOCAL_STORAGE_ANSWERS_KEY,
        JSON.stringify(newAnswers)
      );
      window.localStorage.setItem(LOCAL_STORAGE_VERSION_KEY, DIAGNOSIS_VERSION);
    },
    {
      deep: true,
      debounce: 300,
    }
  );

  const clearStoredAnswers = () => {
    stopSave();
    window.localStorage.removeItem(LOCAL_STORAGE_ANSWERS_KEY);
    window.localStorage.removeItem(LOCAL_STORAGE_VERSION_KEY);
  };

  return {
    clearStoredAnswers,
  };
};
